{
  "big_actions": "งานหลัก",
  "new_orders_other": "ใหม่ {{count}}",
  "new_orders_banner_other": "มีออเดอร์ใหม่เข้ามา {{count}} รายการ",
  "see_orders": "ดูออเดอร์",
  "sound": "เสียงเมื่อมีออเดอร์ใหม่",
  "todo": {
    "title": "สิ่งที่ต้องทำวันนี้",
    "do_it": "ทำเลย",
    "all_done": "ไม่มีงานค้าง — เยี่ยมมาก",
    "could_not_check": "ตรวจไม่ได้",
    "retry": "ลองอีกครั้ง",
    "rows": {
      "bank_transfers_other": "โอนเงินรอตรวจ {{count}} รายการ",
      "payments_overdue_other": "โอนเงินเลยกำหนด {{count}} รายการ",
      "to_ship_other": "ออเดอร์ที่ต้องเตรียมและส่ง {{count}} รายการ",
      "pickup_ready_other": "รอลูกค้ามารับที่ร้าน {{count}} รายการ",
      "export_missing_evidence_other": "ออเดอร์ต่างประเทศยังไม่มีหลักฐานส่งออก {{count}} รายการ",
      "returns_other": "คำขอคืนสินค้า {{count}} รายการ",
      "flagged_other": "ออเดอร์ที่ต้องตรวจ {{count}} รายการ",
      "no_photos_other": "สินค้าไม่มีรูป {{count}} รายการ",
      "no_price_other": "สินค้าไม่มีราคา {{count}} รายการ",
      "unverified_compare_at_other": "ราคาเดิมที่ไม่มีหลักฐาน {{count}} รายการ",
      "prices_to_check_other": "ราคาที่ต้องตรวจ {{count}} รายการ",
      "sold_twice_other": "การ์ดขายซ้ำ {{count}} ใบ",
      "stock_differences_other": "สต็อกไม่ตรง {{count}} รายการ",
      "old_holds_other": "การ์ดถูกจองเกิน 1 วัน {{count}} ใบ",
      "undelivered_messages_other": "งานของระบบที่ส่งไม่สำเร็จ {{count}} รายการ",
      "taxfree_failed_other": "คืนภาษี 免税 ไม่สำเร็จ {{count}} รายการ",
      "taxfree_deadline_other": "ขาย 免税 ใกล้ครบ 90 วัน {{count}} รายการ",
      "taxfree_refund_due_other": "ต้องคืนภาษี 免税 {{count}} รายการ",
      "payouts_due_other": "ยอดฝากขายรอจ่าย {{count}} รายการ",
      "kobutsu_incomplete_other": "古物台帳 ข้อมูลไม่ครบ {{count}} รายการ",
      "shift_variance_one": "เงินขาด/เกินของเครื่องขายที่ต้องตรวจ {{count}} กะ",
      "shift_variance_other": "เงินขาด/เกินของเครื่องขายที่ต้องตรวจ {{count}} กะ"
    },
    "hints": {
      "bank_transfers": "ลูกค้าแจ้งโอนแล้ว — ตรวจบัญชีแล้วกดยืนยันรับเงิน (入金確認)",
      "payments_overdue": "เลยวันชำระแล้ว — เตือนลูกค้าหรือยกเลิก",
      "to_ship": "ออเดอร์ที่จ่ายแล้วรอเตรียมของและส่ง",
      "pickup_ready": "ลูกค้าจะมารับที่ร้าน — ส่งมอบของ",
      "export_missing_evidence": "ใส่หลักฐานการส่งเพื่อให้ยกเว้นภาษีส่งออกได้",
      "returns": "อนุมัติ รับของ หรือคืนเงิน",
      "flagged": "ถูกทำเครื่องหมายให้ตรวจก่อนส่ง",
      "no_photos": "ลูกค้าซื้อสิ่งที่เห็น — ใส่รูปเพิ่ม",
      "no_price": "ทำร่างให้เสร็จ: สภาพ ราคา และสต็อก",
      "unverified_compare_at": "ราคาขีดฆ่าต้องมีหลักฐาน (8 สัปดาห์/ราคาผู้ผลิต) — แก้หรือเอาออก",
      "prices_to_check": "ราคาที่ไม่ได้ตรวจนานแล้ว (สีแดง) — เปิดดู เทียบราคาตลาด แล้วกด “ราคานี้ยังถูกต้อง” หรือแก้ราคา",
      "sold_twice": "ตัดสินว่าใครได้การ์ด แล้วแจ้งลูกค้าอีกคน",
      "stock_differences": "การตรวจตอนกลางคืนพบตัวเลขที่ไม่ตรงกัน",
      "old_holds": "ปล่อยการจองหรือปิดการขายให้เสร็จ",
      "undelivered_messages": "มีบางอย่างไม่ผ่าน — ดูว่าเกิดอะไรขึ้น",
      "taxfree_failed": "คืนเงินให้นักท่องเที่ยวไม่ผ่าน — ลองใหม่หรือเลือกวิธีอื่น",
      "taxfree_deadline": "ต้องได้ผลตรวจศุลกากรภายใน 7 วัน",
      "taxfree_refund_due": "ศุลกากรยืนยันแล้ว — คืนภาษีให้ลูกค้า",
      "payouts_due": "ผู้ฝากขายรอรับเงิน",
      "kobutsu_incomplete": "ขาดการยืนยันตัวตนหรือข้อมูลที่จำเป็น",
      "shift_variance": "ใน 7 วันที่ผ่านมา ผู้จัดการอนุมัติเงินขาด/เกินตอนปิดกะ"
    },
    "source_error": {
      "payments": "ตรวจการโอนเงินไม่ได้",
      "orders": "ตรวจออเดอร์ไม่ได้",
      "catalog": "ตรวจสินค้าไม่ได้",
      "conflicts": "ตรวจการ์ดขายซ้ำไม่ได้",
      "discrepancies": "ตรวจสต็อกไม่ตรงไม่ได้",
      "holds": "ตรวจการ์ดที่ถูกจองไม่ได้",
      "inbox": "ตรวจรายการงานไม่ได้",
      "taxfree": "ตรวจการคืนภาษี 免税 ไม่ได้",
      "settlements": "ตรวจยอดจ่ายผู้ฝากขายไม่ได้",
      "kobutsu": "ตรวจ 古物台帳 ไม่ได้",
      "pos": "ตรวจกะของเครื่องขายไม่ได้"
    }
  },
  "kpi": {
    "title": "ตัวเลข",
    "period": "ช่วงเวลา",
    "periods": {
      "today": "วันนี้",
      "7d": "7 วัน",
      "30d": "30 วัน"
    },
    "error": "โหลดไม่ได้",
    "sales_web": "รับเงิน — เว็บ",
    "sales_pos": "รับเงิน — หน้าร้าน (POS)",
    "payments_count_other": "{{count}} รายการชำระ",
    "orders": "ออเดอร์",
    "new_cards": "การ์ดที่ลงใหม่",
    "sales_note": "ยอดรับเงินรวมภาษี ตามที่บันทึกในการชำระของแต่ละช่องทาง"
  },
  "activity": {
    "title": "การเปลี่ยนแปลงล่าสุด",
    "all": "ดูทั้งหมด",
    "error": "โหลดประวัติการเปลี่ยนแปลงไม่ได้",
    "empty": "ยังไม่มีการเปลี่ยนแปลง",
    "actor": {
      "staff": "พนักงาน",
      "customer": "ลูกค้า",
      "system": "ระบบ"
    },
    "verb": {
      "created": "เพิ่ม{{what}}",
      "updated": "แก้{{what}}",
      "deleted": "ลบ{{what}}",
      "status": "เปลี่ยนสถานะ{{what}}",
      "other": "ทำงานกับ{{what}}"
    },
    "entity": {
      "product": "สินค้า",
      "variant": "รายการของสินค้า",
      "collection": "คอลเลกชัน",
      "order": "ออเดอร์",
      "payment": "การชำระเงิน",
      "refund": "การคืนเงิน",
      "customer": "ลูกค้า",
      "consignor": "ผู้ฝากขาย",
      "consignment_item": "การ์ดฝากขาย",
      "settlement": "ยอดฝากขาย",
      "payout": "การจ่ายผู้ฝาก",
      "unit": "การ์ดในสต็อก",
      "inventory": "สต็อก",
      "staff": "บัญชีพนักงาน",
      "role": "บทบาท",
      "tax_setting": "ตั้งค่าภาษี",
      "setting": "การตั้งค่า",
      "page": "หน้าเว็บ",
      "theme": "ดีไซน์เว็บ",
      "discount": "โค้ดส่วนลด",
      "record": "ข้อมูล"
    }
  }
}
